import React from 'react';
import './onLoad.styles.scss';

const Load = () => {
  return <div className="loader"></div>;
};

export default Load;
